import React from "react";
import ActionDropdown from "~/src/components/action-dropdown";
import {
  BOOKING_STATES,
  BOOKING_STATES_LABELS,
  UPDATABLE_BOOKING_STATES
} from "~/src/consts";

const BookingStateDropdown = ({
  currentState,
  onChange,
  isSmall = false,
  isPrimary = false
}) => {
  const allSelectOptions = Object.keys(UPDATABLE_BOOKING_STATES).map(state => ({
    label: UPDATABLE_BOOKING_STATES[state],
    value: state
  }));

  const getDropdownOptions = bookingState => {
    if (bookingState === BOOKING_STATES.RESERVED) {
      // For Reserved state: only show Accepted and Rejected
      return allSelectOptions.filter(
        option =>
          option.value === BOOKING_STATES.ACCEPTED ||
          option.value === BOOKING_STATES.REJECTED
      );
    }

    // Default behavior: exclude current state
    return allSelectOptions.filter(option => option.value !== bookingState);
  };

  return (
    <ActionDropdown
      isSmall={isSmall}
      isPrimary={isPrimary}
      onChange={onChange}
      value={BOOKING_STATES_LABELS[currentState]}
      options={getDropdownOptions(currentState)}
    />
  );
};

export default BookingStateDropdown;
